// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"styles_modalWrapper__goDHn","bookingButton":"styles_bookingButton__cc_I2"};